/**
 * author andre.pitombeira
 */
export default function ReviewService($http, RESOURCES) {
  function retrieveReview(id) {
    return $http.get(RESOURCES.REVIEW + '/' + id);
  }

  function updateReview(id, data) {
    return $http.put(RESOURCES.REVIEW + '/' + id, data);
  }

  function updateReviews(data) {
    return $http.put(RESOURCES.REVIEW, data);
  }

  function searchReviews(searchUrl) {
    return $http.get(RESOURCES.REVIEW + searchUrl);
  }

  function sendReviewToOps(id) {
    return $http.put(RESOURCES.REVIEW + '/' + id + '/send_to_ops');
  }

  return {
    retrieveReview: retrieveReview,
    updateReview: updateReview,
    updateReviews: updateReviews,
    searchReviews: searchReviews,
    sendReviewToOps: sendReviewToOps,
  };
}



// WEBPACK FOOTER //
// ./src/app/reviews/review.service.js